/* eslint-disable max-len */
/**
 * @function isFunction
 * @param {*} f
 * @returns {boolean}
 */
// eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/explicit-module-boundary-types
const isFunction = (f: any): f is Function => typeof f === 'function';

export { isFunction };
